<style scoped>
  .login { max-width: 60vh; margin: auto; }
  .no-padding-top { padding-top: 0px}
</style>

<template>
  <div class="hero">
    <div class="hero-body animated fadeIn no-padding-top">

      <div class="login">

        <div class="has-text-centered">
          <img src="../assets/images/logo_portal_fundo_transparente.png" />
          <!--<img src="../assets/images/logo_piller.png" v-if="$sistema.nome() === 'PILLER'"/>-->          
          <p class="m-b">Informe seu usuário e senha.</p>
        </div>

        <form @submit.stop.prevent="logar">

          <b-field :type="$errorType('A3_CGC', errors)"
                   :message="errors.first('A3_CGC')">
            <b-input v-model="A3_CGC" name="A3_CGC" v-validate="'required'" size="is-large"
                     placeholder="Usuário" data-vv-as="Usuário"
                     type="text"/>
          </b-field>

          <b-field :type="$errorType('password', errors)"
                   :message="errors.first('password')">
            <b-input v-model="password" name="password" v-validate="'required'"
                     placeholder="******" data-vv-as="Senha" size="is-large"
                     type="password" password-reveal/>
          </b-field>

          <button type="submit" class="button is-fullwidth is-primary" :class="{'is-loading':loading}">
            <b-icon icon="check"/>
            <span>Autenticar</span>
          </button>
        </form>

      </div>

    </div>

    <div class="hero-footer has-text-centered">
      <img src="../assets/images/logobin3.png"/>
      <br/>
      <small>Copyright &copy; {{new Date() | moment("YYYY")}} BIN. Todos os Direitos Reservados ( {{versao}} ) </small>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    created () { this.usuario = this.$air.checkLogado() },
    data () {
      return {
        A3_CGC: '',
        password: '',
        loading: false
      }
    },
    methods: {
      ...mapActions(['setParametros', 'setMenu', 'setVendedor']),
      logar () {
        this.$validator.errors.clear()
        this.$validator.validateAll().then(res => {
          if (res) {
            this.loading = true
            let param = {
              A3_CGC: this.A3_CGC,
              password: this.password
            }
            this.$http.post(this.$URL.AUTENTICAR, param).then(res => {
              this.setParametros(res.body.parametros)
              this.setVendedor(res.body.usuario)
              this.setMenu(res.body.menu)
              this.$air.autenticar(res.body.token, res.body.usuario)
              this.$root.$emit('acessar')
              this.loading = false
            }, res => {
              this.loading = false
              if (res.body['A3_CGC']) {
                this.$validator.errors.add({field: 'A3_CGC', msg: res.body['A3_CGC']})
              } else if (res.body['password']) {
                this.$validator.errors.add({field: 'password', msg: res.body['password']})
              } else {
                this.mensagemFalha(res)
              }
            })
          }
        })
      },
      mensagemFalha (res) {
        this.toast(res)
        this.loading = false
      },
      toast (res) {
        let msg = res.body.message
        let tipo
        switch (res.status) {
          case 0:
          case 404:
            tipo = 'is-warning'
            msg = 'Ops! Nosso servidor está offline, tente novamente mais tarde.'
            break
          case 422:
          case 500:
            tipo = 'is-danger'
            break
          case 200:
            tipo = 'is-info'
            break
          case 201:
            tipo = 'is-success'
            break
        }
        this.$toast.open({
          message: msg,
          type: tipo,
          duration: 7 * 1000
        })
      }
    },
    computed: {
      versao () {
        return this.$sistema.versao()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue